/**
 * Sidebar Collapse Button Component
 *
 * Toggle button for collapsing/expanding the sidebar.
 * Features animated chevron icon rotation.
 */

import { Button } from '@/components/ui/button';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { cn } from '@/lib/utils';

interface SidebarCollapseButtonProps {
  isCollapsed: boolean;
  onToggle: () => void;
}

export function SidebarCollapseButton({ isCollapsed, onToggle }: SidebarCollapseButtonProps) {
  return (
    <div className="border-t px-4 py-4">
      <Button
        variant="ghost"
        size="sm"
        onClick={onToggle}
        className={cn(
          'w-full justify-center transition-all duration-200',
          isCollapsed && 'px-2'
        )}
        aria-label={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
      >
        {isCollapsed ? (
          <ChevronRight className="h-4 w-4" />
        ) : (
          <>
            <ChevronLeft className="h-4 w-4" />
            <span className="ml-2">Collapse</span>
          </>
        )}
      </Button>
    </div>
  );
}
